import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './KBB_Main.html?raw';
import MainProperties from '../../WebCalendar_TS/MainProperties/MainPropertiesV2';
import { EvBookingView, EvBookingEditor } from "../../_loadingHelpers/VAMv2"
import { ToasterHelpers } from "../../../more/Helpers";
import { WebcalendarTypes } from "../../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";



class KBB_Main extends compose(_WidgetBaseSP) {

    templateString: any = template;

    private mainProperties: MdsLax<InstanceType<typeof MainProperties>>;
    private currentBookingEditor: MdsLax<InstanceType<typeof EvBookingEditor>> = null;
    private bookingEditingEnabledForCurrentUser: boolean = false;

    //private _calendarCreated() {

    //    on(this.mainProperties.syncFusionCalendar, "viewtypeChange", lang.hitch(this, this._viewtypeChanged));

    //}
    //_viewtypeChanged(data: any) {
    //    //console.debug("_viewtypeChanged", data);
    //}

    private _itemClickReg: string = null;

    showBookingDetails(item: WebcalendarTypes.WebCalendarItemData_Default): void {

        // auf mobilen Geräten kommt das Event teilweise doppelt daher...
        // kurz merken, was gerade geöffnet war und bei Gleichheit abbrechen
        if (item?.id == this._itemClickReg) {
            return; //
        }

        this._itemClickReg = item?.id;
        setTimeout(lang.hitch(this, function () { this._itemClickReg = null; }), 200);

        if (item.Classname == "ev_booking") {
            let selectedCalendar = this.mainProperties.getCurrentSelectedCalendar();
            let calendarID = "";
            if (selectedCalendar) {
                calendarID = selectedCalendar.ID;
            }

            let additionalData = {
                selectedHtCalendarID: calendarID
            };

            let view = new EvBookingView();
            view.setup(item.id, item.columnview_head_text, additionalData);
            view.startup();
        } else {

            this.mainProperties.openDefaultDetailView(item); // standard aufrufen
        }
    }

    private _checkIfBookingEditingEnabledForCurrentUser(): void {

        this.hasUserRole(["EvBooking_Create", "EvBooking_Edit"], lang.hitch(this, this._showBookingEditorInterface));
    }

    private _showBookingEditorInterface(bool?: boolean): void {
        //console.log("_showBookingEditorInterface", bool);
        this.bookingEditingEnabledForCurrentUser = bool === true;

        if (this.bookingEditingEnabledForCurrentUser == true && this.hasUserRole("EvBooking_Edit")) {

            let createBookingBtn = this.UiModder.domConstruct.create("BUTTON", {
                innerHTML: this.translations["WebCalendar_SidebarPane_btnLabel_createBooking"],
                className: "mds-button-base round mds-hover-dark w3-block",
                onclick: lang.hitch(this, this._onclickOpenBookingEditor)
            });

            this.mainProperties.addCustomPane("evBookingEditorPane", this.translations["WebCalendar_SidebarPane_paneLabel_bookingEditor"], createBookingBtn, "fas fa-calendar-plus");

        } else {
            this.mainProperties.removePane("evBookingEditorPane");
        }
    }

    private _setupMainPropertes(): void {

        if (this.mainProperties != null) {
            this.mainProperties.destroy();
            this.mainProperties = null;
        }

        this.mainProperties = new MainProperties();

        //on(this.mainProperties, "calendarCreated", lang.hitch(this, this._calendarCreated));

        this.UiModder.domConstruct.place(this.mainProperties.domNode, this.domNode, "first");

        let detailFct = lang.hitch(this, this.showBookingDetails);

        this.mainProperties.setMainConfig({
            itemDetails: {
                customItemClickFunction: detailFct
                //requestUrl: 
            },
            userProperties: {
                customFunctionName: "Webtool_API_Webcalendar__GetUserProperties",
                requestUrl: "Calendar/GetUserProperties",
                //requestParams: [{ name: "jsonData", value: { user: "unknown" } }]
            },
            filterData: {
                customFunctionName: "Webtool_API_Webcalendar__GetFilterData"
            },
            defaultDisplaySettings: {
                b_show_end_time: true,
                //hideColumnHead: true
            }
        });

        this.mainProperties.startup();

        this._preparePanels();

        // Titel überschreiben, der vom Webkalender gesetzt würde
        //this.mainProperties.setTitles(
        //    this.stringFormat(this.translations["KWittCalendar__MainTitle"], this.translations["MainTitle"]),
        //    this.translations["KWittCalender__Title"]);

    }

    private _preparePanels(): void {
        if (!this.mainProperties) {
            return;
        }

        let props = this.mainProperties;

        //props.addCustomPane(....)

    }

    private _doubleClickFct(clickedDate: Date) {
        if (this.bookingEditingEnabledForCurrentUser == true) {
            this._onclickOpenBookingEditor(null);

            if (this.currentBookingEditor != null) {
                this.currentBookingEditor.setAttributeValue("date_start", clickedDate);
            }
        }
    }

    private _onclickOpenBookingEditor(item: WebcalendarTypes.WebCalendarItemData_Default): void {

        if (this.bookingEditingEnabledForCurrentUser == true) {

            //if (this.mainProperties.itemClickDlg && this.mainProperties.itemClickDlg._destroyed != true) {
            //    try {

            //        this.mainProperties.itemClickDlg.close();
            //    } catch (ex) {
            //        // nich so schlümm
            //    }
            //};

            if (this.currentBookingEditor != null) {
                if (this.currentBookingEditor._destroyed !== true) this.currentBookingEditor.destroy();
                this.currentBookingEditor = null;
            }

            this.currentBookingEditor = new EvBookingEditor();
            //this.currentBookingEditor.setEvBookingEditorConfig(this.evBookingEditorSectionsConfig);

            if (item && item.id) {
                this.currentBookingEditor.loadEntityById(item.id);
            } else {
                this.currentBookingEditor.startup();
                this.currentBookingEditor.setStartupState("ready");
            }

            //this.currentBookingEditor.on("saved", lang.hitch(this, this._onUpdateItemChanges_Response, "success"));

        } else {
            alert("Current User has no permissions for booking editor")
        }
    }

    //private _onUpdateItemChanges_Response(response: string) {
    //    this.mainProperties._onUpdateItemChanges_Response(response);
    //}


    publishToastMessage(text: string, icon: ToasterHelpers.ToasterIcons = ToasterHelpers.ToasterIcons.none, timeout?: number, extendedMessage?: string): void {
        if (!this.mainProperties) {
            alert(text);
            console.error(text, extendedMessage);
            return;
        }
        this.mainProperties.publishToastMessage(text, icon, timeout, extendedMessage)
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
        //this._isStartup = true;
        //this._continueWithSession();
        //this._checkUrlParameters();
        this._setupMainPropertes();

        this._checkIfBookingEditingEnabledForCurrentUser();

    }

}

export default mdsWidget(KBB_Main);